export default {
  data() {
    return {
      mediaQuery: {},
      mediaQueryMatch: null,
      mediaQueryListener: null,
    };
  },
  methods: {
    /**
         * Provides a mediaQuery object in the data option.
         *
         * @param {Number} width viewport width in px.
         * @param {Boolean} listener Should the component listen to changes?
         * @param {String} name If you have multiple media queries you should provide a name to keep track of them.
         * @returns mediaQuery object in the data option.
         */
    _media(width, listener = false, type = 'max', name = 'default') {
      if (this.mediaQueryMatch) {
        this.mediaQueryMatch.removeEventListener('change', this.mediaQueryListener);
      }

      this.mediaQueryMatch = window.matchMedia(`(${type}-width: ${width}px)`);
      const _this = this;

      this.mediaQueryListener = function (e) {
        _this.mediaQuery = {
          ..._this.mediaQuery,
          [name]: {
            media: _this.mediaQueryMatch,
            match: _this.mediaQueryMatch.matches,
            targetWidth: width,
            listener: 'change',
            width: window.innerWidth,
            height: window.innerHeight,
          },
        };

        _this.$forceUpdate();
      };

      this.mediaQueryListener();

      listener
        ? this.mediaQueryMatch.addEventListener('change', this.mediaQueryListener)
        : '';

      return this.mediaQueryMatch.matches;
    },
  },
};
